import styled from 'styled-components';

export const AccountsLogin = styled.div`
  justify-self: center;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.white.a10};
  border-radius: 5px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.white.a10};
  margin-bottom: 1em;
  padding: 2em;
  box-shadow: 0 4px 14px 5px rgba(78, 84, 107, 0.05);

  &:hover {
    border: solid 1px ${({ theme }) => theme.baseBlue.a10};

    h1 {
      color: ${({ theme }) => theme.baseBlue.a10} !important;
    }
  }

  &:active {
    opacity: 0.8;
  }
`;

export const AccountsHeader = styled.h1`
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  font-size: 1.66em;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.5px;
`;
